import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isShowAccountCompleteModal: false,
  isShowLeftMenu: false,
  qrSizes: [],
  configs: [],
};
const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {

    setIsShowAccountCompleteModal(state, action) {
      state.isShowAccountCompleteModal = action.payload;
    },
    setIsShowLeftMenu(state, action) {
      state.isShowLeftMenu = action.payload;
    },
    setQrSizes(state, action) {
      state.qrSizes = action.payload;
    },
    setConfigs(state, action) {
      state.configs = action.payload;
    },
  },
});

export const { setIsShowAccountCompleteModal, setIsShowLeftMenu, setQrSizes, setConfigs } = mainSlice.actions;
const mainReducer = mainSlice.reducer;

export default mainReducer;